export default "__VITE_ASSET__CsE67P$1__"